import React from 'react';
import Sidebar from '../Layouts/Dashboard/Sidebar';
import TopBar from '../Layouts/Dashboard/TopBar';



interface MainLayoutProps {
  activeComponent: string;
  setActiveComponent: (component: string) => void;
  onLogout: () => void;
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ 
  activeComponent, 
  setActiveComponent, 
  onLogout, 
  children 
}) => {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar 
        activeComponent={activeComponent} 
        setActiveComponent={setActiveComponent}
        onLogout={onLogout}
      />
      
      <div style={{ 
        flex: 1,
        minWidth: 0,          // ← prevents flex child from overflowing
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: '#f9fafb',
        overflow: 'hidden',
      }}>
        <TopBar  />

        <div style={{ 
          flex: 1,
          padding: '24px',    // ← reduced from 40px
          overflowY: 'auto',
          overflowX: 'hidden', // ← clips any accidental horizontal overflow
          minWidth: 0,
        }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;